import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Component({
    selector: 'app-reset-pin-success',
    templateUrl: './reset-pin-success.component.html',
    styleUrls: ['./reset-pin-success.component.scss'],
    standalone: false
})
export class ResetPinSuccessComponent implements OnInit {
  constructor(private _appService: AppService) {}

  ngOnInit(): void {
    this._appService.setLeftMenuVisibilityStatus(false);
  }

  onMyAccount() {
    this._appService.setLeftMenuVisibilityStatus(true);
  }
}
